<template>
  <v-app id="page">
    <headerTest/>
    <v-main class="test">
      <!--<links/>-->
      <router-view/>
    </v-main>
    <footerTest/>
  </v-app>
</template>

<script>
import headerTest from "./components/headerTest"
//import links from "./components/old/links"
import footerTest from "./components/footerTest"

export default {
  name: 'App',

  components: {
    headerTest,
    //links,
    footerTest,
  },
};
</script>

<style lang="scss">
@import "utilities/variables";
@import url("https://s3.unistra.fr/master/common/assets/fonts/unistra-font/1.0.0/css/unistra-font.css?AWSAccessKeyId=M2M78RKXPAP75Y692QZX&Signature=Ros22u4Tp0Dy106qr0rRkGBPoJM%3D&Expires=1870971370");
@import url("https://s3.unistra.fr/master/common/assets/fonts/unistra-symbol/1.0.4/css/unistra-symbol.css?AWSAccessKeyId=M2M78RKXPAP75Y692QZX&Signature=lfTwAVnRXjgZc9ryRpAcWhiMbCA%3D&Expires=1876298241");
@import url("https://s3.unistra.fr/master/common/assets/fonts/nova-icons/1.0.2/css/nova-icons.css?AWSAccessKeyId=M2M78RKXPAP75Y692QZX&Signature=hFFKhRhE9%2B1xVyIi%2F%2BQPD%2BftVbk%3D&Expires=1887617035");

@font-face {
  font-family: "Unistra A";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
}

html {
  line-height:1.15;
  height: 100%;
  -webkit-text-size-adjust:100%;
  -webkit-tap-highlight-color:rgba(0,0,0,0)
}

body {
  background-color: $background-color;
  color: $text-color;
  position: relative;
  font-family: 'Unistra A';

  margin:0;
  font-size: 0.9375rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
}

page {
  width: 100%;
  min-height: 100vh; /* 1 */
  display: flex; /* 2 */
  flex-grow: 1;
  flex-direction: column; /* 3 */
}

.test {
  background-color: $background-color;

  flex-grow:1; /* 4 */
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-color;
  position: relative;
  min-height: 100vh;
  margin: 0;

  display: grid;
  grid-template-rows: auto 1fr auto;
}

#nav {
  padding: 2em;
}

a {
  font-weight: bold;
  color: $text-color;
  text-decoration: none;
}

a.router-link-exact-active {
  color: $button-color-blue;
}
</style>
